import { NavLink } from "react-router-dom";
import { 
    HomeModernIcon,
    DocumentTextIcon,
    UsersIcon,
    CurrencyDollarIcon,
    ChartBarIcon,
    UserCircleIcon
} from "@heroicons/react/16/solid";
import { MenuItem, LeftBarProps } from "../model/Model";
import { useAuth } from "../context/AuthContext";

// import "../css/styles.css"

// Menus par rôle
const adminMenuItems: MenuItem[] = [
    { id: "dashboard", label: "Dashboard", path: "/", icon: <ChartBarIcon /> },
    { id: "biens", label: "Tous les biens", path: "biens", icon: <HomeModernIcon /> },
    { id: "contrats", label: "Tous les contrats", path: "contrats", icon: <DocumentTextIcon /> },
    { id: "locataires", label: "Locataires", path: "locataires", icon: <UsersIcon /> },
    { id: "paiements", label: "Paiements", path: "paiements", icon: <CurrencyDollarIcon /> },
    { id: "profil", label: "Mon Profil", path: "profil", icon: <UserCircleIcon /> }
];

const proprietaireMenuItems: MenuItem[] = [
    { id: "dashboard", label: "Dashboard", path: "/", icon: <ChartBarIcon /> },
    { id: "biens", label: "Mes biens", path: "biens", icon: <HomeModernIcon /> },
    { id: "contrats", label: "Mes contrats", path: "contrats", icon: <DocumentTextIcon /> },
    { id: "locataires", label: "Mes locataires", path: "locataires", icon: <UsersIcon /> },
    { id: "paiements", label: "Paiements", path: "paiements", icon: <CurrencyDollarIcon /> },
    { id: "profil", label: "Mon Profil", path: "profil", icon: <UserCircleIcon /> }
];

const locataireMenuItems: MenuItem[] = [
    { id: "dashboard", label: "Dashboard", path: "/", icon: <ChartBarIcon /> },
    { id: "contrats", label: "Mes contrats", path: "contrats", icon: <DocumentTextIcon /> },
    { id: "paiements", label: "Mes paiements", path: "paiements", icon: <CurrencyDollarIcon /> },
    { id: "profil", label: "Mon Profil", path: "profil", icon: <UserCircleIcon /> }
];

function LeftBar({ menuItems, className = "", onMenuItemClick }: LeftBarProps = {}){
    const { user } = useAuth();

    // Déterminer les items de menu selon le rôle
    let items = menuItems;
    
    if (!items) {
        switch (user?.role) {
            case 'ADMIN':
                items = adminMenuItems;
                break;
            case 'PROPRIETAIRE':
                items = proprietaireMenuItems;
                break;
            case 'LOCATAIRE':
                items = locataireMenuItems;
                break;
            default:
                items = [];
        }
    }
    
    const handleMenuClick = (item: MenuItem) => {
        if (onMenuItemClick) {
            onMenuItemClick(item);
        }
    };

    return (
        <nav className={`bg-gray-900 text-white min-h-screen w-64 shadow-2xl ${className}`}>
            {/* Header de la sidebar */}
            <div className="p-6 border-b border-gray-700">
                <h2 className="text-xl font-bold text-white">
                    🏢 GesLocative
                </h2>
                <p className="text-gray-400 text-sm mt-1">Gestion immobilière</p>
            </div>

            {/* Menu de navigation */}
            <ul className="py-4 space-y-2">
                {items.map((item: MenuItem) => (
                    <li key={item.id} className="px-4">
                        <NavLink 
                            to={item.path}
                            onClick={() => handleMenuClick(item)}
                            className={({ isActive }) => `
                                flex items-center py-3 px-4 rounded-lg transition-all duration-200 group
                                ${isActive 
                                    ? 'bg-blue-600 text-white shadow-lg transform scale-105' 
                                    : 'text-gray-300 hover:bg-gray-800 hover:text-white hover:transform hover:translate-x-1'
                                }
                            `}
                        >
                            {item.icon && (
                                <span className={`w-5 h-5 mr-3 transition-transform duration-200 group-hover:scale-110`}>
                                    {item.icon}
                                </span>
                            )}
                            <span className="font-medium">{item.label}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    )
}

export default LeftBar;